/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { UserSubscription } from '@modules/ui-types'

import { SAVE_MARKETPLACE_TOKEN } from '../../../../constants/actions'

export interface State {
  token?: string
  partner?: UserSubscription
}

const initialState = {}

export default function marketplaceReducer(state: State = initialState, action: any) {
  const { token, partner, type } = action

  if (type === SAVE_MARKETPLACE_TOKEN) {
    return {
      ...state,
      token,
      partner,
    }
  }

  return state
}
